import { useEffect, useState } from "react";

/**
 * 自定义hook：计算广告高度
 * 监听广告元素的高度变化，包括窗口大小变化和元素尺寸变化
 */
export function useAdHeight() {
  const [adHeight, setAdHeight] = useState(0);

  useEffect(() => {
    const calculateAdHeight = () => {
      const ad = document.getElementById("dfp-ad-lb1-wrapper");
      if (ad) {
        const height = ad.getBoundingClientRect().height;
        setAdHeight(height);
      }
    };

    // 初始计算
    calculateAdHeight();

    // 监听窗口大小变化
    window.addEventListener("resize", calculateAdHeight);

    // 监听广告元素尺寸变化
    let adObserver: ResizeObserver | null = null;
    const ad = document.getElementById("dfp-ad-lb1-wrapper");
    if (ad) {
      adObserver = new ResizeObserver(calculateAdHeight);
      adObserver.observe(ad);
    }

    return () => {
      window.removeEventListener("resize", calculateAdHeight);
      if (adObserver && ad) {
        adObserver.disconnect();
      }
    };
  }, []);

  return adHeight;
}
